module.exports = __webpack_public_path__ + "static/media/ios-browsers.691f0713.svg";